import { SelectOption } from '@frontend/basic-forms';
import { IoTEnumClient } from '@frontend/iot/api';
import { IoTState, IoTStateName } from '@frontend/iot/types';
import { useEffect, useState } from 'react';

import { IoTStateSelectProps } from './iot-state-select.component';

interface ViewProps {
    options: SelectOption<IoTStateName>[];
}

const useIoTStateSelect = (props: IoTStateSelectProps): ViewProps => {
    const [options, changeOptions] = useState<SelectOption<IoTStateName>[]>([]);

    useEffect(() => {
        IoTEnumClient.fetchIoTStates().then((states) => {
            return changeOptions(
                states
                    .filter((state) => (props.subset ? props.subset.includes(state) : true))
                    .map((state) => {
                        const found = IoTState.ALL.find((t) => t.value === state);
                        if (found) {
                            return {
                                value: found.value,
                                label: found.value,
                                display: found.displayName
                            };
                        } else
                            return {
                                value: state,
                                label: state.replace(/_/g, ' ')
                            };
                    })
            );
        });
    }, []);

    return { options };
};

export default useIoTStateSelect;
